import React from 'react';
import AppRoutes from './Router/Routes';
import './App.css';

function App() {
  return (
    <AppRoutes/>
  );
}

export default App;